let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3W0F3")).then(() => parcelRequire('eITgL'));